import React, { useContext } from 'react';
import { DateTime } from 'luxon';
import { useTheme } from '@mui/material/styles';
import StoreContext from '../context/StoreContext';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const SmsStatusLabel = ({messages, type, isSendingSms}) => {
  const theme = useTheme();
  const { time_zone } = useContext(StoreContext);

  const parseTime = (timeStamp) => {
    return DateTime.fromISO(timeStamp).setZone(time_zone).toFormat('MM-dd-yyyy hh:mm')
  }

  return (
    <Box className='flex items-start' style={{ margin: '0.025em 0', padding: '0', fontSize: '.8rem',}}>
      <strong className='w-40'>{type}:</strong>
      <Box className='flex flex-col'>
        {isSendingSms && 'Sending SMS'}
        {
          messages?.length > 0 && <>
          {
            messages?.map((message, index) => (
              <label key={index}>
                <strong className='mr-1'>
                  <em style={message?.Status === 'SENT' ? {color: theme.palette.success.main} : {color: theme.palette.error.main}}>
                    {message?.Status === 'SENT' ? 'Message sent successfully at' : message?.Message}
                    </em>
                </strong>
                { parseTime(message?.Timestamp) }
              </label>
            ))
          }
          </>
        }
        {
          ((messages === undefined || messages?.length === 0) && !isSendingSms) && '-'
        }
      </Box>
    </Box>
  );
}


SmsStatusLabel.propTypes = {
  messages: PropTypes.array,
  type: PropTypes.string,
  isSendingSms: PropTypes.bool
}

export default SmsStatusLabel;
